import { useEffect, useRef, useState } from "react";
import "./LoginScreen.css";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import { Login_Form_Model, Signup_Form_Model } from "../../Model/UserModel";
import { useDispatch } from "react-redux";
import {
  RESET_SIGNUP_USER,
  USER_LOGIN,
  USER_SIGNUP,
} from "../../Action/UserAction";
import { useSelector } from "react-redux";
import Loading from "../../Components/Loading";
export default function MobileLoginScreen() {
  const [LoginScreen, setLoginScreen] = useState(false);
  const [visible, setVisible] = useState(false);
  const [SignupForm, setSignupForm] = useState(Signup_Form_Model);
  const [LoginForm, setLoginForm] = useState(Login_Form_Model);
  const { Signup_User_Loading, Signup_User_Success, Signup_User_Error } =
    useSelector((state) => state.USER_SIGNUP_REDUCER);

  const dispatch = useDispatch();
  const Navigate = useNavigate();
  const PasswordRef = useRef();
  const { state } = useLocation();
  // const recaptchaRef = useRef();
  const handleChange = (e) => {
    setSignupForm({ ...SignupForm, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // const Validator = Signup_Validator(SignupForm);

    dispatch(
      USER_SIGNUP({
        ...SignupForm,
        activity:
          window.innerWidth <= 530 ? "User Sign up through Mobile App !" : null,
      })
    );

    setTimeout(() => {
      PasswordRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 500);
  };

  const { Login_User_Loading, Login_User, Login_User_Error } = useSelector(
    (state) => state.USER_LOGIN_REDUCER
  );

  // const LoginAttmpt = GET_LOCAL("Sattmpt");

  const handleChangeLogin = (e) => {
    setLoginForm({ ...LoginForm, [e.target.name]: e.target.value });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    // if (LoginAttmpt) {
    //   let user_captcha = document.getElementById("user_captcha_input").value;
    //   if (validateCaptcha(user_captcha) === true) {
    //     dispatch(USER_LOGIN(LoginForm));
    //   } else {
    //     dispatch({
    //       type: USER_LOGIN_FAILED,
    //       payload: "Error - Captcha doesn't matched !",
    //     });
    //   }
    // } else {
    dispatch(USER_LOGIN(LoginForm));
    // }

    setTimeout(() => {
      PasswordRef?.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 700);
  };

  useEffect(() => {
    if (Signup_User_Success) {
      setTimeout(() => {
        setSignupForm(Signup_Form_Model);
        dispatch(RESET_SIGNUP_USER());
        if (!state) {
          Navigate("/login");
        }
      }, 4500);
    }

    // if (Signup_User_Error === "Error - You are already registered!") {
    //   if (state?.TLAT === "Take_Test") {
    //     dispatch(Take_Test_Det(SignupForm));
    //   } else if (state?.PackageId) {
    //     localStorage.setItem(
    //       "Cart_Package_Id",
    //       JSON.stringify(state?.PackageId)
    //     );

    //     localStorage.setItem(
    //       "Package_Timing",
    //       JSON.stringify({
    //         Timings: state?.Timings,
    //         CustomTimings: state?.CustomTimings,
    //         EmailAddress: SignupForm?.EmailAddress,
    //       })
    //     );
    //   }
    //   if (state?.PackageId) {
    //     dispatch(
    //       AddToCart(
    //         {
    //           packageId: state?.PackageId,
    //           EmailAddress: SignupForm?.EmailAddress,
    //           Timings: state?.Timings,
    //           CustomTimings: state?.CustomTimings,
    //           ClassMode: state?.ClassMode,
    //         },
    //         "student/cart/withEmail"
    //       )
    //     );
    //   }
    // }
  }, [Signup_User_Success, Navigate, dispatch, Signup_User_Error]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (Login_User) {
      window.OneSignalDeferred = window.OneSignalDeferred || [];
      window.OneSignalDeferred.push(async function (OneSignal) {
        // console.log("OneSignal methods:", Object.keys(OneSignal));
        OneSignal.login(Login_User?._id);
        // OneSignal.User.addEmail(Login_User?.EmailAddress);
      });
      Navigate("/dashboard");
    }
  }, [dispatch, Navigate, Login_User]);

  return (
    <>
      <div className="Login_Mobile_New_Screen">
        {Login_User_Loading ? <Loading /> : ""}
        <div class="container">
          {/* <!-- Toggle Controls --> */}
          {/* <input type="radio" id="login-toggle" name="form-toggle" checked />
          <input type="radio" id="signup-toggle" name="form-toggle" /> */}

          {/* <!-- Header Toggle Buttons --> */}
          <div
            class="header-toggle"
            onClick={() => setLoginScreen(!LoginScreen)}
          >
            <label class="toggle-btn signup-btn">
              {!LoginScreen ? "Sign Up" : "Login"}
            </label>
            {/* <label for="login-toggle" class="toggle-btn admin-btn">Admin Login</label> */}
          </div>

          {/* <!-- Form Container --> */}
          <div class="form-container">
            <div class="logo">
              <img src="/testifyi_logo.svg" style={{ height: "60px" }} />
            </div>
            {!LoginScreen ? (
              <>
                <div class="form-content login-form">
                  <h2>Login to Student</h2>
                  <form onSubmit={handleLogin}>
                    <div class="input-group">
                      <input
                        type="text"
                        placeholder="Email Address"
                        name="EmailAddress"
                        value={LoginForm.EmailAddress}
                        onChange={handleChangeLogin}
                        required
                      />
                    </div>
                    <div class="input-group">
                      <input
                        name="Password"
                        value={LoginForm.Password}
                        onChange={handleChangeLogin}
                        type={visible ? "text" : "password"}
                        placeholder="Password"
                        required
                      />
                      {visible ? (
                        <span
                          onClick={() => setVisible(false)}
                          class="eye-icon"
                        >
                          <IoMdEyeOff />
                        </span>
                      ) : (
                        <span onClick={() => setVisible(true)} class="eye-icon">
                          <IoMdEye />
                        </span>
                      )}
                    </div>
                    <button type="submit" class="submit-btn">
                      Login
                    </button>
                    {Login_User_Error ? (
                      <p
                        ref={PasswordRef}
                        style={{ color: "red", textAlign: "center" }}
                      >
                        {Login_User_Error}
                      </p>
                    ) : (
                      ""
                    )}
                  </form>
                </div>
              </>
            ) : (
              <div class="form-content ">
                <h2>Create Account</h2>
                <form onSubmit={handleSubmit}>
                  <div class="input-row">
                    <div class="input-group half">
                      <input
                        type="text"
                        name="First_Name"
                        value={SignupForm.First_Name}
                        onChange={handleChange}
                        placeholder="First Name"
                        required
                      />
                    </div>
                    <div class="input-group half">
                      <input
                        type="text"
                        placeholder="Last Name"
                        name="Last_Name"
                        value={SignupForm.Last_Name}
                        onChange={handleChange}
                        required
                      />
                    </div>
                  </div>
                  <div class="input-group">
                    <input
                      type="email"
                      placeholder="Email Address"
                      name="EmailAddress"
                      value={SignupForm.EmailAddress}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div class="input-group">
                    <input
                      type="number"
                      name="PhoneNo"
                      value={SignupForm.PhoneNo}
                      onChange={handleChange}
                      placeholder="Phone No (optional)"
                    />
                  </div>
                  <button
                    disabled={Signup_User_Loading}
                    type="submit"
                    class="submit-btn"
                  >
                    {Signup_User_Loading ? "loading..." : "Signup"}
                  </button>

                  {Signup_User_Error ? (
                    <p
                      ref={PasswordRef}
                      style={{ color: "red", textAlign: "center" }}
                    >
                      {Signup_User_Error}
                    </p>
                  ) : (
                    ""
                  )}

                  {Signup_User_Success ? (
                    <p
                      ref={PasswordRef}
                      style={{ color: "green", textAlign: "center" }}
                    >
                      {Signup_User_Success}
                    </p>
                  ) : (
                    ""
                  )}
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
